export default function QrCodeJazigo({
  navigate,
  user,
  onLogout,
  falecidos,
}) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #faf7f2, #db935b)",
        padding: "32px 20px",
      }}
    >
      <div
        style={{
          maxWidth: 900,
          margin: "0 auto",
        }}
      >
        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 50,
          }}
        >
          <div
            style={{
              width: 90,
              height: 90,
              borderRadius: "50%",
              background: "#fde6d8",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
              boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
            }}
          >
            <span
              style={{
                fontSize: 38,
                color: "#E8956A",
              }}
            >
              ✝
            </span>
          </div>

          <h1
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 42,
              fontWeight: 700,
              color: "#2d2d2d",
              marginBottom: 12,
            }}
          >
            Lista de Pessoas
          </h1>

          <p
            style={{
              fontSize: 16,
              color: "#777",
              marginBottom: 22,
            }}
          >
            Selecione uma pessoa para visualizar sua homenagem memorial
          </p>

          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fde6d8",
              color: "#c96b36",
              padding: "10px 18px",
              borderRadius: 999,
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            {falecidos.length} pessoas encontradas
          </div>
        </div>

        {/* Lista */}
        {falecidos.length > 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 22,
            }}
          >
            {falecidos.map((falecido) => (
              <button
                key={falecido.id}
                onClick={() => {
                  navigate("memorial", {
                    navigate,
                    user,
                    onLogout,
                    selectedFalecido: falecido,
                  });
                }}
                style={{
                  width: "100%",
                  border: "1px solid #f6d7c5",
                  borderRadius: 28,
                  background: "#fff",
                  padding: 24,
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
                  textAlign: "left",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.12)";
                  e.currentTarget.style.border =
                    "1px solid #E8956A";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 14px rgba(0,0,0,0.06)";
                  e.currentTarget.style.border =
                    "1px solid #f6d7c5";
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  {/* Avatar */}
                  <div
                    style={{
                      width: 72,
                      height: 72,
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, #f7c7a8 0%, #E8956A 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontSize: 28,
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    {falecido.nome_completo?.charAt(0)}
                  </div>

                  {/* Conteúdo */}
                  <div style={{ flex: 1 }}>
                    <h2
                      style={{
                        fontFamily: "'Playfair Display', serif",
                        fontSize: 28,
                        color: "#2d2d2d",
                        marginBottom: 6,
                      }}
                    >
                      {falecido.nome_completo}
                    </h2>

                    <p
                      style={{
                        fontSize: 15,
                        color: "#888",
                      }}
                    >
                      Clique para visualizar a homenagem memorial
                    </p>
                  </div>

                  {/* Ícone */}
                  <div
                    style={{
                      width: 46,
                      height: 46,
                      borderRadius: "50%",
                      background: "#fff3eb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#E8956A",
                      fontSize: 22,
                      fontWeight: 700,
                    }}
                  >
                    →
                  </div>
                </div>
              </button>
            ))}
          </div>
        ) : (
          <div
            style={{
              height: 320,
              background: "#fff",
              borderRadius: 32,
              border: "2px dashed #f3cdb8",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              padding: 24,
              boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
            }}
          >
            <div
              style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "#fde6d8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 30,
                color: "#E8956A",
                marginBottom: 20,
              }}
            >
              ☁
            </div>

            <h2
              style={{
                fontSize: 26,
                color: "#444",
                marginBottom: 10,
              }}
            >
              Nenhum resultado encontrado
            </h2>

            <p
              style={{
                fontSize: 15,
                color: "#888",
                maxWidth: 400,
                lineHeight: 1.6,
              }}
            >
              Não foi possível encontrar pessoas vinculadas a este jazigo.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
